import { initObservationTool } from "@deep-consulting-solutions/observation-ui";
import { isInternalRenderPath } from "./internalRenderBootstrap";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

if (!isInternalRenderPath()) {
  initObservationTool({
    apiBaseUrl: `${API_BASE_URL}/api`,
    getAuthToken: () => localStorage.getItem("token") ?? "",
  });
}
